import { Action, Frame, FrameAnchor, FrameForm, FrameLoader, FrameTarget } from '@studiometa/ui';

/**
 * @typedef {{}} ComponentProps
 */

/**
 * Component component.
 * @augments {Frame<ComponentProps>}
 */
export default class Blog extends Frame {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Blog',
    components: {
      Action,
      FrameAnchor,
      FrameForm,
      FrameTarget,
      FrameLoader,
    },
    refs: ['btnMobile', 'close[]', 'panel'],
  };

  /**
   *
   */
  onBtnMobileClick() {
    document.documentElement.classList.add('panel-is-open');
    this.$refs.panel.classList.remove('max-m:translate-x-full');
  }

  /**
   *
   */
  onCloseClick() {
    document.documentElement.classList.remove('panel-is-open');
    this.$refs.panel.classList.add('max-m:translate-x-full');
  }
}
